





















































import Vue from 'vue'
import { INHALER_USAGE_ICONS_BASE64 } from '@/components/patient-stats/graphs/mapping-chart-options/constants'
import * as R from 'ramda'
import { InhalerTypes, InhalerUsage } from '@/jsonapi/CommonTypes'

export default Vue.extend({
  props: {
    patientWithMappingReports: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    combinedInhalerUsageIcons() {
      const result = []
      if (this.maintenanceInhalerUsages.length >= 1 && this.relieverInhalerUsages.length >= 1) {
        result.push({ src: this.convertBase64ForSrc(INHALER_USAGE_ICONS_BASE64.SQUARE_CIRCLE), width: 16 })
      }

      if (this.maintenanceInhalerUsages.length >= 1 && this.relieverInhalerUsages.length >= 2) {
        result.push({ src: this.convertBase64ForSrc(INHALER_USAGE_ICONS_BASE64.SQUARE_SQUARE), width: 16 })
      }

      if (this.maintenanceInhalerUsages.length >= 2 && this.relieverInhalerUsages.length >= 1) {
        result.push({ src: this.convertBase64ForSrc(INHALER_USAGE_ICONS_BASE64.CIRCLE_CIRCLE), width: 20 })
      }

      if (this.maintenanceInhalerUsages.length >= 2 && this.relieverInhalerUsages.length >= 2) {
        result.push({ src: this.convertBase64ForSrc(INHALER_USAGE_ICONS_BASE64.CIRCLE_SQUARE), width: 20 })
      }
      return result
    },
    hasSleepingData() {
      return this.patientWithMappingReports.sleepingPeriods && this.patientWithMappingReports.sleepingPeriods.length
    },
    hasInterruptionData() {
      return (
        this.patientWithMappingReports.majorInterruptions && this.patientWithMappingReports.majorInterruptions.length
      )
    },
    hasActivityData() {
      return (
        this.patientWithMappingReports.combinedWalkingDuration &&
        this.patientWithMappingReports.combinedWalkingDuration.length
      )
    },
    dividedInhalerUsages() {
      const groupByType = R.groupBy<InhalerUsage>(usage => usage.type, this.patientWithMappingReports.inhalerUsages)
      return {
        maintenanceUsages: groupByType[InhalerTypes.Maintenance],
        relieverUsages: groupByType[InhalerTypes.Reliever],
      }
    },
    maintenanceInhalerUsages() {
      if (this.dividedInhalerUsages.maintenanceUsages === undefined) {
        return []
      }

      return this.dividedInhalerUsages.maintenanceUsages.map((usage, index) => ({
        name: usage.name,
        icon: this.convertBase64ForSrc(
          index === 0 ? INHALER_USAGE_ICONS_BASE64.SQUARE : INHALER_USAGE_ICONS_BASE64.CIRCLE
        ), // TODO remove hardcode
      }))
    },
    relieverInhalerUsages() {
      if (this.dividedInhalerUsages.relieverUsages === undefined) {
        return []
      }

      return this.dividedInhalerUsages.relieverUsages.map((usage, index) => ({
        name: usage.name,
        icon: this.convertBase64ForSrc(
          index === 0 ? INHALER_USAGE_ICONS_BASE64.CIRCLE_BG : INHALER_USAGE_ICONS_BASE64.SQUARE_BG
        ), // TODO remove hardcode
      }))
    },
  },
  methods: {
    convertBase64ForSrc(base64) {
      return 'data:image/png;base64, ' + base64
    },
  },
})
